import { CognitoIdentityClient } from '@aws-sdk/client-cognito-identity';
import { RekognitionClient, DetectFacesCommand } from '@aws-sdk/client-rekognition';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-provider-cognito-identity';

const AWS_REGION = 'us-east-1';

const rekognitionClient = new RekognitionClient({
  region: AWS_REGION,
  credentials: fromCognitoIdentityPool({
    client: new CognitoIdentityClient({ region: AWS_REGION }),
    identityPoolId: 'us-east-1:6cfea440-acc4-4679-b74e-10213813f544',
  }),
});

export const detectFace = async (base64string) => {
  const params = { Image: { Bytes: Buffer.from(base64string, 'base64') }, Attributes: ['ALL'] };
  return rekognitionClient.send(new DetectFacesCommand(params));
};
